module.exports = __webpack_public_path__ + "media/gallery/photo05-4ebeed22.webp";